// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LX-z","inlineTitle":"MX-z","sponsoredAdsWrapper":"NX-z","marketplaceRecosWrapper":"OX-z"};